import { Outlet } from "react-router-dom";
import { AppStateProvider } from "../context/AppStateContext";
import { GeoDirectoryProvider } from "../context/GeoDirectoryContext";

/** App data providers for signed-in HO console (not used on `/login`). */
export function AuthenticatedShell() {
  return (
    <AppStateProvider>
      <GeoDirectoryProvider>
        <Outlet />
      </GeoDirectoryProvider>
    </AppStateProvider>
  );
}
